module.exports = __webpack_public_path__ + "static/media/tradicional.02c5e7c2.png";